import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";

import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import SplitNumber from "../_Components/SplitNumber";
import { Button } from "react-bootstrap";
let showPrice = Intl.NumberFormat("en-US");
function DataGridUsedPromoCodeByUser(props) {
  const { data, checkBoxList2: checkBoxList, setCheckBoxList2: setCheckBoxList } = props;

  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }

  const handleSelect = (node) => {
    const data = {
      id: node.id,
      promoCategoryCommisionId: node.promoCategoryCommisionId,
      promoCategoryId: node.promoCategoryId,
    };
    checkBoxList.some((item) => data.id == item.id)
      ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id))
      : !_.isEmpty(checkBoxList)
        ? checkBoxList.some(
          (item) =>
            data.promoCategoryCommisionId == item.promoCategoryCommisionId &&
            data.promoCategoryId == item.promoCategoryId,
        )
          ? setCheckBoxList((checkBoxList) => [...checkBoxList, data])
          : SwalMessage({ title: "جهت انتخاب گروهی ،گروه تخفیف و کمیسیون باید یکسان باشند", iSsuccess: false })
        : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
  };
  const redRows = useMemo(() => {
    return data?.data?.map(row =>
      (row.profit < 0 && row.currentStatus == 3)
    );
  }, [data])
  const columns = useMemo(() => [
    {
      accessor: "#",
      Header: "انتخاب",
      align: "center",
      minWidth: 15,
      Cell: ({ row }) => (
        <>
          <div>
            <input
              type="checkbox"
              onChange={() => handleSelect(row.original)}
              className="ml-6 pl-6 my-1 "
              checked={!_.isEmpty(checkBoxList) ? checkBoxList.some((item) => row.original.id == item.id) : false}
            />
          </div>
        </>
      ),
    },
    {
      accessor: "agentName",
      Header: "نماینده فروش",
      minWidth: 150,
    },
    {
      accessor: "id",
      Header: "بلیط",
      minWidth: 50,
      Cell: ({ row }) => {
        return (
          <Link target="_blank" to={`/viewOrderContents/${row.original.basketId}`}>
            {row.original.id}
          </Link>
        );
      },
    },
    {
      accessor: "userPhoneNumber",
      Header: "شماره موبایل",
      minWidth: "100px",
      Cell: ({ row }) => <div className="ltr">{row.original.userPhoneNumber}</div>,
    },
    {
      accessor: "promoCode",
      Header: "کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "amusmentServiceName",
      Header: "نام سرویس",
      minWidth: "100px",
    },
    {
      accessor: "createdTimeBasketItem",
      Header: "تاریخ خرید",
      minWidth: "100px",
    },
    {
      accessor: "checkInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    {
      accessor: "originalPrice",
      Header: "قیمت اصلی",
      minWidth: "100px",
      Cell: ({ row }) => <>{showPrice.format(row.original.originalPrice)}</>,
    },
    {
      accessor: "salePrice",
      Header: "قیمت فروش سایت",
      minWidth: "130px",
      Cell: ({ row }) => <>{showPrice.format(row.original.salePrice)}</>,
    },
    {
      accessor: "promoCodeDiscountPrice",
      Header: "مبلغ تخفیف",
      minWidth: "100px",
      Cell: ({ row }) => <>{showPrice.format(row.original.promoCodeDiscountPrice)}</>,
    },
    {
      accessor: "price",
      Header: "قیمت نهایی کاربر",
      minWidth: "130px",
      Cell: ({ row }) => <>{showPrice.format(row.original.price)}</>,
    },
    {
      accessor: "agentCommisionPrice",
      Header: "کمیسیون",
      minWidth: "100px",
      Cell: ({ row }) => (
        <>
          {row.original.currentStatus != 3
            ? "درانتظار"
            : row.original.profit >= 0 ? (
              <div className="">
                <SplitNumber number={row.original.agentCommisionPrice} />
              </div>
            ) : (
              <div className="text-danger">
                <SplitNumber number={row.original.agentCommisionPrice} />
              </div>
            )
          }
        </>
      )
    },
    {
      accessor: "payToWarrantyAmount",
      Header: "پرداختی تامین کننده",
      minWidth: "130px",
      Cell: ({ row }) => <>{showPrice.format(row.original.payToWarrantyAmount)}</>,
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت کنسلی",
      minWidth: "30px",
      Cell: ({ row }) => (
        <div
          className={`text-center d-inline-block rounded-pill px-4 py-1  ${row.original.cancelStatus == "کنسل_شد" ? "text-danger bg-light-danger " : ""}`}
        >
          {row.original.cancelStatus}
        </div>
      ),
    },
    {
      accessor: "status",
      Header: "وضعیت",
      minWidth: "30px",
    },

    {
      accessor: "promoCodePublicationTypeS",
      Header: "نوع کدتخفیف",
      minWidth: "100px",
    },
    {
      accessor: "agentCommissionSettlementStatusString",
      Header: "تسویه",
      minWidth: "50px",
      Cell: ({ row }) => (
        <div
          className={
            row.original.agentCommissionSettlementStatus === 1
              ? "text-green-dataGrid"
              : row.original.agentCommissionSettlementStatus === 2
                ? "text-orange-dataGrid"
                : row.original.agentCommissionSettlementStatus === 3
                  ? "text-danger"
                  : ""
          }
        >
          {row.original.agentCommissionSettlementStatusString}
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className={`btn btn-light-primary btn-sm mr-2 btn-icon ${(row.original.currentStatus != 3 || row.original.agentCommissionSettlementStatus == 1) && "invisible"}`}
            title="ویرایش"
            type="button"
            onClick={() => {
              props.setSelectedUsedCommision(row.original)
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <i
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => { }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-custom-class="tooltip-dark"
            title={showDetail(row.original.details)}
            data-bs-delay-hide="1000"
          >
            <b>i</b>
          </i>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable redRows={redRows} config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridUsedPromoCodeByUser;
